export function roleCheck(userRoles: string[] | null | undefined, allowedRoles: string[]) {
    if (!userRoles) return false;

    return userRoles.some(role => {
        return allowedRoles.indexOf(role) !== -1
    })
}